import { render, staticRenderFns } from "./TestimonialComponent.vue?vue&type=template&id=4b110a00&lang=pug&"
import script from "./TestimonialComponent.vue?vue&type=script&lang=js&"
export * from "./TestimonialComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports